(() => {
  const companyId = document.body.dataset.klaviyoCompany;
  if (companyId && /^[a-zA-Z0-9]{5,12}$/.test(companyId)) {
    const alreadyLoaded = [...document.scripts].some((script) => script.src.includes('static.klaviyo.com/onsite/js/'));
    if (!alreadyLoaded) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://static.klaviyo.com/onsite/js/${encodeURIComponent(companyId)}/klaviyo.js`;
      document.head.append(script);
    }
  }
  function initialize(root = document) {
    root.querySelectorAll('[data-signup]').forEach((area) => {
      if (area.dataset.initialized) return;
      area.dataset.initialized = 'true';
      const slot = area.querySelector('.klaviyo-slot');
      const fallback = area.querySelector('.signup-fallback');
      if (slot && fallback && !area.querySelector('.form-message')) {
        const refresh = () => {
          if (slot.querySelector('form, input[type="email"], [role="dialog"]')) {
            fallback.hidden = true;
          }
          const successHeading = slot.querySelector('.klaviyo-form-richtext h1');
          if (successHeading && !slot.querySelector('input[type="email"]')) {
            const invitation = area.closest('.invitation');
            successHeading.id = successHeading.id || 'SignupConfirmed-' + (invitation?.querySelector('h2')?.id || 'launch');
            successHeading.setAttribute('role', 'heading');
            successHeading.setAttribute('aria-level', '2');
            invitation?.setAttribute('aria-labelledby', successHeading.id);
          }
        };
        new MutationObserver(refresh).observe(slot, {childList: true, subtree: true});
        refresh();
      }
    });
    root.querySelectorAll('[data-native-signup]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const button = form.querySelector('button[type="submit"]');
        if (button) {
          button.disabled = true;
          button.dataset.originalText = button.textContent;
          button.textContent = button.dataset.loading;
          setTimeout(() => {
            button.disabled = false;
            button.textContent = button.dataset.originalText;
          }, 12000);
        }
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-native-signup] button:disabled').forEach((button) => {
      button.disabled = false;
      if (button.dataset.originalText) button.textContent = button.dataset.originalText;
    });
  });
})();
